/* eslint-disable no-unused-vars */

import popup from '../utilities/popup-alert';

window.Webflow = {
  onRemoveBegin: function (data, status, xhr) {
    $(this)
      .closest('.js-basket-row-wrapper')
      .append('<div class="content-loader"></div>')
      .addClass('basket-row-wrapper--processing');
  },
  onRemoveSuccess: function (data, status, xhr) {
    popup.show(
      'Item removed from the order',
      popup.types.info,
      popup.icons.info
    );
  },
  onRemoveError: function (xhr, status, error) {},
  onUpdateBegin: function (data, status, xhr) {
    $(this)
      .closest('.js-basket-row-wrapper')
      .append('<div class="content-loader"></div>')
      .addClass('basket-row-wrapper--processing');
  },
  onUpdateSuccess: function (data, status, xhr) {
    popup.show('Quantity Updated', popup.types.info, popup.icons.info);
  },
  onUpdateError: function (xhr, status, error) {
    popup.show(
      "Sorry, we couldn't update this item",
      popup.types.info,
      popup.icons.info
    );
  }
};

$('.js-webflow-buyer-selectbox').on('change', function (event) {
  var optionSelected = $('option:selected', this);
  if (optionSelected.length > 0) {
    window.location.href = $(optionSelected).data('url');
  }
});

$('.js-webflow-control').on('click', function () {
  $(this).closest('form').submit();
  $(this).find('.loader').show();
  $('.js-webflow-control').attr('disabled', '');
});

$('body').on('change', '.js-webfms-system-choice', function (e) {
  var choice = $(this).val();
  if (choice == 'other') {
    $('.js-webfms-other-systems').removeClass('hidden');
  } else {
    $('.js-webfms-other-systems').addClass('hidden');
  }
});
